import React from 'react'
import { render } from 'react-dom'
import { Router, Route, Redirect, hashHistory } from 'react-router'
import Message from './components/Message'
import Form from './components/Form'
import './index.css'

render((
  <Router history={ hashHistory }>
    <Redirect from="/message/" to="/message/1"></Redirect>
    <Redirect from="/" to="/send"></Redirect>
    <Route path="/send" component={ Form }></Route>
    <Route path="/message/:id" component={ Message }></Route>
  </Router>
), document.querySelector('#root'))



// WEBPACK FOOTER //
// ./src/index.js